import { makeStyles } from '@mui/styles';
import map from '../../assets/images/home/yassir-fleet-map.png';

export const useStyles = makeStyles((theme) => ({
    sidebar: {
        background: '#000032',
        backgroundImage: `url(${map})`,
        backgroundRepeat: 'no-repeat',
        height: '100vh',
        overflowY: 'auto'
    },
    collapsed_sidebar: {
        background: '#000032',
        backgroundImage: `url(${map})`,
        backgroundRepeat: 'no-repeat',
        height: '100vh',
        alignItems: 'center',
        justifyContent: 'center',
        overflowY: 'auto'
    },
    logo_container: {
        alignItems: 'center',
        borderBottom: 'solid 1px 44ppx #362C5E',
        display: "flex",
        justifyContent: 'center',
        padding: '40px 0',
    },
    menu_container: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        padding: '40px 0',
    },
    collapsed_menu_container: {
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        padding: '40px 0',
    },
    active_menu_item: {
        cursor: 'pointer',
        alignItems: 'center',
        background: '#35087C',
        borderRadius: '8px',
        color: '#FFF',
        display: "flex",
        flexDirection: 'row',
        gap: '12px',
        justifyContent: 'flex-start',
        margin: '0 3% !important',
        padding: '20px 18px',
        textTransform: 'capitalize',
        '&:hover': {
            background: '#35087C !important',
        },
    },
    active_menu_item_special: {
        cursor: 'pointer',
        alignItems: 'center',
        background: '#35087C',
        borderRadius: '8px',
        color: '#FFF',
        display: "flex",
        flexDirection: 'row',
        gap: '12px',
        justifyContent: 'flex-start',
        margin: '0 3% !important',
        padding: '20px 18px',
        textTransform: 'capitalize',
    },
    collapsed_active_menu_item: {
        cursor: 'pointer',
        alignItems: 'center',
        background: '#35087C',
        borderRadius: '8px',
        color: '#FFF',
        display: "flex",
        flexDirection: 'row',
        gap: '12px',
        justifyContent: 'center',
        margin: '0 3% !important',
        padding: '12px',
        textTransform: 'capitalize',
        width: '50%',
        '&:hover': {
            background: '#35087C !important',
        },
    },
    menu_item: {
        color: '#FFF',
        alignItems: 'center',
        display: "flex",
        flexDirection: 'row',
        gap: '12px',
        justifyContent: 'flex-start',
        margin: '0 3% !important',
        padding: '20px 18px',
        textTransform: 'capitalize',
        cursor: 'pointer',
        borderRadius: '8px',
        '&:hover': {
            background: '#35087C !important',
        },
    },
    collapse_item: {
        alignItems: 'center',
        display: "flex",
        flexDirection: 'row',
        gap: '12px',
        justifyContent: 'flex-start',
        margin: '0 3% !important',
        padding: '20px 18px',
    },
    collapsed_menu_item: {
        color: '#FFF',
        alignItems: 'center',
        borderRadius: '8px',
        display: "flex",
        flexDirection: 'row',
        gap: '12px',
        justifyContent: 'center',
        margin: '0 3% !important',
        padding: '20px 18px',
        textTransform: 'capitalize',
        width: '100%',
        '&:hover': {
            background: '#35087C !important',
        },
    },
    collapsed_collapse_item: {
        alignItems: 'center',
        display: "flex",
        flexDirection: 'row',
        gap: '12px',
        justifyContent: 'flex-start',
        margin: '0 3% !important',
        padding: '20px',
        width: '100%',
    },
    menu_item_center: {
        position: 'relative',
        alignItems: 'center',
        color: '#FFF',
        display: "flex",
        flexDirection: 'row',
        gap: '12px',
        justifyContent: 'flex-start',
        padding: '20px 18px',
        textTransform: 'capitalize',
        verticalAlign: 'center',
        margin: '0 3% !important',
        cursor: 'pointer',
        top: `${window.innerHeight / 200}% !important`,
    },
    collapsed_menu_item_center: {
        position: 'relative',
        alignItems: 'center',
        color: '#FFF',
        display: "flex",
        flexDirection: 'row',
        gap: '12px',
        justifyContent: 'center',
        textTransform: 'capitalize',
        verticalAlign: 'center',
        margin: '0 3% !important',
        padding: '0',
        cursor: 'pointer',
        top: `${window.innerHeight / 200}% !important`,
        width: '100%',
    },
    txtSidebar: {
        display: 'block',
        textDecoration: 'none',
        fontFamily: 'Gellix',
        fontSize: '16px',
        fontWeight: 500,
        color: '#FFFFFF',
        float: 'left',
        '@media (max-width:1200px)': {
            display: 'none',
        },
    },
    txtSidebarRight: {
        display: 'block',
        textDecoration: 'none',
        fontFamily: 'TheSansArab',
        fontSize: '16px',
        fontWeight: 600,
        color: '#FFFFFF',
        float: 'right',
        '@media (max-width:1200px)': {
            display: 'none',
        },
    },
    flesh: {
        display: 'block',
        '@media (max-width:1200px)': {
            display: 'none',
        },
    },
    iconLink: {
        color: "#FFF",
        height: "20px",
        width: "20px",
        float: 'left',
        marginRight: '12px',
    },
    iconLinkRight: {
        color: "#FFF",
        height: "20px",
        width: "20px",
        float: 'right',
        marginLeft: '12px',
    },
    divCtn: {
        border: '1px solid transparent',
        width: '87%',
        textAlign: 'left',
        position: 'absolute',
        padding: '18px 0px 16px 15px',
        marginLeft: '-15px',
    },
    linkSidebar: {
        display: 'contents',
        textDecoration: 'none',
        color: '#FFFFFF',
    },

    logoWeb: {
        display: 'block',
        '@media (max-width:1200px)': {
            display: 'none',
        },
    },
    logoMob: {
        display: 'none',
        '@media (max-width:1200px)': {
            display: 'block',
        },
    },
    ctnSubLink: {
        width: '100%',
    },
}));